import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { CdnImage } from '../../primitives/CdnImage';
interface AuthorAvatarProps extends React.ComponentProps<typeof CdnImage> {
  sizeVariant?: 'small' | 'medium' | 'large' | 'extraLarge';
}
const sizeMap = {
  small: 35,
  medium: 45,
  large: 55,
  extraLarge: 65
};
export const AuthorAvatar = t0 => {
  const $ = _c(12);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      sizeVariant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const sizeVariant = t1 === undefined ? "small" : t1;
  const size = sizeMap[sizeVariant];
  let t2;
  if ($[3] !== size) {
    t2 = {
      width: size,
      height: size,
      borderRadius: "50%",
      overflow: "hidden",
      border: "1px solid",
      borderColor: "neutral.lighter"
    };
    $[3] = size;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      objectFit: "cover",
      objectPosition: "top center"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size) {
    t4 = <CdnImage {...props} width={size} height={size} style={t3} />;
    $[6] = props;
    $[7] = size;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Box sx={t2}>{t4}</Box>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};